// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WidgetClassListPagingResultModel from '../../model/widget-class-list-paging-result-model';
import WidgetClassListPagingResultDTO from '../dto/widget-class-list-paging-result-dto';
import dtoSchema from '../schemas/widget-class-list-paging-result-schema';
import WidgetClassListModel from '../../model/widget-class-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class WidgetClassListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WidgetClassListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => WidgetClassListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: WidgetClassListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<WidgetClassListPagingResultDTO>): WidgetClassListPagingResultModel;
  static toModel(dto: DeepPartial<WidgetClassListPagingResultDTO> | undefined | null): WidgetClassListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<WidgetClassListPagingResultDTO> | undefined | null): WidgetClassListPagingResultModel | undefined {
    return dto ? new WidgetClassListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WidgetClassListPagingResultModel> | WidgetClassListPagingResultModel): WidgetClassListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as WidgetClassListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WidgetClassListPagingResultModel, can not map to WidgetClassListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
